'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _immutableSorted = require('immutable-sorted');

var _StateEngine2 = require('./StateEngine');

var _StateEngine3 = _interopRequireDefault(_StateEngine2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 *  Copyright (c) 2017, Applitopia, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the MIT-style license found in the
 *  LICENSE file in the root directory of this source tree.
 *
 *  
 */


var cast = function cast(value) {
  return value;
};

var RepoEngine = function (_StateEngine) {
  _inherits(RepoEngine, _StateEngine);

  function RepoEngine(schema) {
    _classCallCheck(this, RepoEngine);

    return _possibleConstructorReturn(this, (RepoEngine.__proto__ || Object.getPrototypeOf(RepoEngine)).call(this, schema));
  }

  _createClass(RepoEngine, [{
    key: 'repoReducer',
    value: function repoReducer() {
      var stateReducer = _get(RepoEngine.prototype.__proto__ || Object.getPrototypeOf(RepoEngine.prototype), 'stateReducer', this).call(this);

      var repoOptionsProps = {
        history: 1000,
        showRepo: false
      };
      var repoBranchProps = {
        currentIndex: -1,
        live: true,
        states: [],
        actions: []
      };
      var repoProps = {
        version: 0,
        options: repoOptionsProps,
        currentBranch: 'master',
        branches: {
          'master': repoBranchProps
        }
      };
      var initialRepo = (0, _immutableSorted.fromJS)(repoProps);

      var verifyBranch = function verifyBranch(repo, branchName) {
        var branches = repo.get("branches");

        if (!branches.has(branchName)) {
          throw Error("the branch does not exist: " + branchName);
        }
      };

      var stateReduce = function stateReduce(mutableRepo, repo, action) {
        if (!Object.isFrozen()) {
          throw new Error("Action object is not frozen");
        }

        var options = mutableRepo.get("options");
        var history = options.get("history");
        var currentBranch = mutableRepo.get("currentBranch");
        verifyBranch(repo, currentBranch);
        var branches = mutableRepo.get("branches");
        var branch = branches.get(currentBranch);
        var newBranch = branch.withMutations(function (mutableBranch) {
          var currentIndex = mutableBranch.get("currentIndex");
          var live = mutableBranch.get("live");
          var states = mutableBranch.get("states");
          var actions = mutableBranch.get("actions");
          var state = states.get(states.size - 1);
          var newState = stateReducer(state, action);
          var newStates = states.withMutations(function (mutableStates) {
            mutableStates.push(newState);

            while (mutableStates.size > history) {
              mutableStates.shift();

              if (currentIndex > 0) {
                currentIndex--;
              }
            }
          });
          var newActions = actions.withMutations(function (mutableActions) {
            var actionCopy = action;
            mutableActions.push(actionCopy);

            while (mutableActions.size > history) {
              mutableActions.shift();
            }
          });

          if (live) {
            currentIndex = newStates.size - 1;
          }

          mutableBranch.set("currentIndex", currentIndex);
          mutableBranch.set("states", newStates);
          mutableBranch.set("actions", newActions);
        });
        var newBranches = branches.set(currentBranch, newBranch);
        mutableRepo.set("branches", newBranches);
      };

      var repoReduceMutable = function repoReduceMutable(mutableRepo, repo, action) {
        switch (action.type) {
          case 'DUXEN_INIT':
            {
              var initAction = cast(action);
              var rbp = {
                currentIndex: 0,
                live: true,
                states: [(0, _immutableSorted.fromJS)(initAction.state)],
                actions: [action]
              };
              mutableRepo.set("currentBranch", "master");
              mutableRepo.set("branches", (0, _immutableSorted.fromJS)({
                'master': rbp
              }));
              break;
            }

          case 'DUXEN_CREATE_BRANCH':
            {
              var repoAction = cast(action);
              var branches = repo.get("branches");

              if (branches.has(repoAction.branchName)) {
                throw Error("the branch already exists: " + repoAction.branchName);
              }

              var newBranch = initialRepo.getIn(["branches", "master"]);
              var newBranches = branches.set(repoAction.branchName, newBranch);
              mutableRepo.set("branches", newBranches);
              break;
            }

          case 'DUXEN_SWITCH_BRANCH':
            {
              var _repoAction = cast(action);

              verifyBranch(repo, _repoAction.branchName);
              mutableRepo.set("currentBranch", _repoAction.branchName);
              break;
            }

          case 'DUXEN_SAVE_BRANCH':
            {
              var _repoAction2 = cast(action);

              var currentBranch = mutableRepo.get("currentBranch");

              var _branches = repo.get("branches");

              var branch = _branches.get(currentBranch);

              var currentIndex = branch.get("currentIndex");

              var _newBranch = branch.withMutations(function (mutableBranch) {
                var newStates = mutableBranch.get("states").slice(0, currentIndex + 1);
                mutableBranch.set("states", newStates);
                var newActions = mutableBranch.get("actions").slice(0, currentIndex + 1);
                mutableBranch.set("actions", newActions);
                mutableBranch.set("currentIndex", currentIndex);
              });

              var _newBranches = _branches.set(_repoAction2.branchName, _newBranch);

              mutableRepo.set("branches", _newBranches);
              break;
            }

          case 'DUXEN_RESET_BRANCH':
            {
              var _repoAction3 = cast(action);

              verifyBranch(repo, _repoAction3.branchName);

              var _currentBranch = mutableRepo.get("currentBranch");

              var _branches2 = repo.get("branches");

              var _branch = _branches2.get(_repoAction3.branchName);

              var _currentIndex = _branch.get("currentIndex");

              var _newBranch2 = _branch.withMutations(function (mutableBranch) {
                var newStates = mutableBranch.get("states").slice(0, _currentIndex + 1);
                mutableBranch.set("states", newStates);
                var newActions = mutableBranch.get("actions").slice(0, _currentIndex + 1);
                mutableBranch.set("actions", newActions);
                mutableBranch.set("currentIndex", _currentIndex);
              });

              var _newBranches2 = _branches2.set(_currentBranch, _newBranch2);

              mutableRepo.set("branches", _newBranches2);
              break;
            }

          case 'DUXEN_REMOVE_BRANCH':
            {
              var _repoAction4 = cast(action);

              verifyBranch(repo, _repoAction4.branchName);

              var _currentBranch2 = mutableRepo.get("currentBranch");

              if (_currentBranch2 === _repoAction4.branchName) {
                throw Error("cannot remove branch that is current");
              }

              var _branches3 = repo.get("branches");

              var _newBranches3 = _branches3.remove(_repoAction4.branchName);

              mutableRepo.set("branches", _newBranches3);
              break;
            }

          case 'DUXEN_GO_FORWARD':
            {
              var _repoAction5 = cast(action);

              var _currentBranch3 = mutableRepo.get("currentBranch");

              var _branches4 = repo.get("branches");

              var _branch2 = _branches4.get(_currentBranch3);

              var _currentIndex2 = _branch2.get("currentIndex");

              var states = _branch2.get("states");

              var steps = _repoAction5.steps;

              var _newBranch3 = _branch2.withMutations(function (mutableBranch) {
                var newCurrentIndex = _currentIndex2 + steps;

                if (newCurrentIndex < 0) {
                  newCurrentIndex = 0;
                } else if (newCurrentIndex >= states.size) {
                  newCurrentIndex = states.size - 1;
                }

                mutableBranch.set("currentIndex", newCurrentIndex);
                mutableBranch.set("live", false);
              });

              var _newBranches4 = _branches4.set(_currentBranch3, _newBranch3);

              mutableRepo.set("branches", _newBranches4);
              break;
            }

          case 'DUXEN_GO_BACK':
            {
              var _repoAction6 = cast(action);

              var _currentBranch4 = mutableRepo.get("currentBranch");

              var _branches5 = repo.get("branches");

              var _branch3 = _branches5.get(_currentBranch4);

              var _currentIndex3 = _branch3.get("currentIndex");

              var _states = _branch3.get("states");

              var _steps = _repoAction6.steps;

              var _newBranch4 = _branch3.withMutations(function (mutableBranch) {
                var newCurrentIndex = _currentIndex3 - _steps;

                if (newCurrentIndex < 0) {
                  newCurrentIndex = 0;
                } else if (newCurrentIndex >= _states.size) {
                  newCurrentIndex = _states.size - 1;
                }

                mutableBranch.set("currentIndex", newCurrentIndex);
                mutableBranch.set("live", false);
              });

              var _newBranches5 = _branches5.set(_currentBranch4, _newBranch4);

              mutableRepo.set("branches", _newBranches5);
              break;
            }

          case 'DUXEN_GO_LIVE':
            {
              var _currentBranch5 = mutableRepo.get("currentBranch");

              var _branches6 = repo.get("branches");

              var _branch4 = _branches6.get(_currentBranch5);

              var _states2 = _branch4.get("states");

              var _newBranch5 = _branch4.withMutations(function (mutableBranch) {
                var newCurrentIndex = _states2.size - 1;
                mutableBranch.set("currentIndex", newCurrentIndex);
                mutableBranch.set("live", true);
              });

              var _newBranches6 = _branches6.set(_currentBranch5, _newBranch5);

              mutableRepo.set("branches", _newBranches6);
              break;
            }

          case 'DUXEN_SET_OPTION':
            {
              var _repoAction7 = cast(action);

              mutableRepo.setIn(["options", _repoAction7.optionName], _repoAction7.optionValue);
              break;
            }

          default:
            {
              stateReduce(mutableRepo, repo, action);
              break;
            }
        }
      };

      var repoReduce = function repoReduce(repo, action) {
        if (repo === undefined) {
          repo = initialRepo;
        }

        return repo.withMutations(function (mutableRepo) {
          repoReduceMutable(mutableRepo, repo, action);
        });
      };

      return repoReduce;
    }
  }]);

  return RepoEngine;
}(_StateEngine3.default);

exports.default = RepoEngine;